import { render, staticRenderFns } from "./TrainingGradeDistributionChart.vue?vue&type=template&id=b94611d0"
import script from "./TrainingGradeDistributionChart.vue?vue&type=script&lang=js"
export * from "./TrainingGradeDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports